// GLOW-UP cart v5 (Oct 2026): gamified progress bar + complementary cross-sell.
// Offers are AUTOMATIC discounts (FALL15 >= Rs.1,499, FESTIVE20 >= Rs.5,999) - no codes are applied from here.
// Tiers judged on the PRE-DISCOUNT subtotal (original_total_price), same as Shopify's minimums.
// Cross-sell reads #gu-hot-json (20-day bestsellers, in-stock sizes only) rendered by the cart template.
(function () {
  var TIERS = [
    { min: 149900, label: '15% OFF', name: 'FALL15', icon: '🏷️' },
    { min: 599900, label: '20% OFF', name: 'FESTIVE20', icon: '🎁' }
  ];

  (function(){ if (document.getElementById('gu-cart-css')) return; var s = document.createElement('style'); s.id = 'gu-cart-css'; s.textContent = ".gu-cart-progress{background:linear-gradient(135deg,#F2FAF8,#FFFFFF);border:1px solid #D5ECE7;border-radius:14px;padding:12px 14px 30px;margin:10px 0 14px;position:relative;overflow:visible}\n.gu-cp-msg{font-size:13.5px;line-height:1.45;color:#1B1815;margin-bottom:14px}\n.gu-cp-msg b{font-weight:700}\n.gu-cp-next{font-size:12px;color:#555}\n.gu-cp-track{position:relative;height:8px;border-radius:99px;background:#E6EEEC;margin:0 14px}\n.gu-cp-fill{position:absolute;left:0;top:0;bottom:0;border-radius:99px;background:linear-gradient(90deg,#3FB8A3,#12806F);transition:width .8s cubic-bezier(.2,.8,.2,1);overflow:hidden}\n.gu-cp-fill::after{content:\"\";position:absolute;inset:0;background:linear-gradient(90deg,transparent,rgba(255,255,255,.55),transparent);transform:translateX(-100%);animation:gucpShine 2.2s infinite}\n@keyframes gucpShine{to{transform:translateX(100%)}}\n.gu-cp-node{position:absolute;top:50%;transform:translate(-50%,-50%);display:flex;flex-direction:column;align-items:center}\n.gu-cp-dot{width:28px;height:28px;border-radius:50%;background:#fff;border:2px solid #CFDAD7;display:flex;align-items:center;justify-content:center;font-size:14px;box-shadow:0 2px 6px rgba(0,0,0,.08)}\n.gu-cp-node.is-hit .gu-cp-dot{background:#12806F;border-color:#12806F;color:#fff;font-weight:700}\n.gu-cp-start .gu-cp-dot{background:#fff!important;border-color:#3FB8A3!important}\n.gu-cp-lab{position:absolute;top:32px;font-size:10.5px;font-weight:700;white-space:nowrap;color:#8A8274;letter-spacing:.02em}\n.gu-cp-node.is-hit .gu-cp-lab{color:#12806F}\n.gu-cp-node.is-pop .gu-cp-dot{animation:gucpPop .7s ease}\n@keyframes gucpPop{0%{transform:scale(.6)}60%{transform:scale(1.35)}100%{transform:scale(1)}}\n.gu-cp-confetti{position:absolute;left:0;right:0;top:0;height:0;pointer-events:none}\n.gu-cp-confetti i{position:absolute;top:10px;font-style:normal;font-size:18px;animation:gucpBurst 1.3s ease-out forwards;opacity:0}\n.gu-cp-confetti i:nth-child(1){left:15%}.gu-cp-confetti i:nth-child(2){left:32%;animation-delay:.1s}.gu-cp-confetti i:nth-child(3){left:50%;animation-delay:.05s}.gu-cp-confetti i:nth-child(4){left:68%;animation-delay:.15s}.gu-cp-confetti i:nth-child(5){left:85%;animation-delay:.08s}\n@keyframes gucpBurst{0%{opacity:1;transform:translateY(20px) scale(.5)}100%{opacity:0;transform:translateY(-40px) scale(1.2) rotate(25deg)}}\n.gu-xs-title{font-size:15px;font-weight:700;margin:18px 0 10px;text-transform:lowercase}\n.gu-xs-row{display:flex;gap:10px;overflow-x:auto;scrollbar-width:none;padding-bottom:4px}\n.gu-xs-row::-webkit-scrollbar{display:none}\n.gu-xs-card{flex:0 0 40%;max-width:180px}\n.gu-xs-card img{width:100%;aspect-ratio:3/4;object-fit:cover;object-position:top;border-radius:10px;display:block;background:#F2EEE6}\n.gu-xs-name{font-size:12px;font-weight:600;line-height:1.3;margin-top:6px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}\n.gu-xs-foot{display:flex;justify-content:space-between;align-items:center;margin-top:4px;gap:4px}\n.gu-xs-price{font-size:12px;font-weight:700}.gu-xs-price s{font-weight:400;color:#8A8274;font-size:11px}\n.gu-xs-add{font-size:11.5px;font-weight:700;border:1.5px solid #12806F;color:#12806F;background:#fff;border-radius:99px;padding:4px 10px;white-space:nowrap}\n.gu-xs-add:disabled{background:#12806F;color:#fff}\n.gu-xs-sizes{display:flex;flex-wrap:wrap;gap:4px;margin-top:6px}\n.gu-xs-sizes button{font-size:11px;min-width:30px;padding:4px 6px;border:1px solid #1B1815;border-radius:6px;background:#fff}"; (document.head || document.documentElement).appendChild(s); })();
  var isCartPage = window.location.pathname.indexOf('/cart') === 0;
  function inr(cents) { return '₹' + Math.ceil(cents / 100).toLocaleString('en-IN'); }

  // visual position: 0 -> 0%, tier1 -> 45%, tier2 -> 100%
  function pos(total) {
    if (total <= 0) return 0;
    if (total < TIERS[0].min) return (total / TIERS[0].min) * 45;
    if (total < TIERS[1].min) return 45 + ((total - TIERS[0].min) / (TIERS[1].min - TIERS[0].min)) * 55;
    return 100;
  }

  function renderProgress(total, saved) {
    var el = document.querySelector('[data-gu-progress]');
    if (!el) return;
    if (total <= 0) { el.innerHTML = ''; return; }
    var level = total >= TIERS[1].min ? 2 : total >= TIERS[0].min ? 1 : 0;
    var msg;
    if (level === 2) msg = '<b>🏆 Max discount unlocked!</b> 20% OFF applied' + (saved > 0 ? ' · you save <b>' + inr(saved) + '</b>' : '');
    else if (level === 1) msg = '<b>🎉 15% OFF unlocked</b>' + (saved > 0 ? ' · saving ' + inr(saved) : '') + '<br><span class="gu-cp-next">add <b>' + inr(TIERS[1].min - total) + '</b> more for 20% OFF 🎁</span>';
    else msg = 'You\'re <b>' + inr(TIERS[0].min - total) + '</b> away from <b>15% OFF</b> 🔓';
    var prev = 0;
    try { prev = parseInt(sessionStorage.getItem('gu_tier') || '0', 10); sessionStorage.setItem('gu_tier', String(level)); } catch (e) {}
    var burst = level > prev;
    function node(i, left) {
      var t = TIERS[i], hit = total >= t.min;
      return '<div class="gu-cp-node' + (hit ? ' is-hit' : '') + (burst && i === level - 1 ? ' is-pop' : '') + '" style="left:' + left + '%">' +
        '<span class="gu-cp-dot">' + (hit ? '✓' : t.icon) + '</span><span class="gu-cp-lab">' + t.label + '</span></div>';
    }
    el.innerHTML = '<div class="gu-cp-msg">' + msg + '</div>' +
      '<div class="gu-cp-track"><div class="gu-cp-fill" style="width:' + pos(total) + '%"></div>' +
      '<div class="gu-cp-node is-hit gu-cp-start" style="left:0%"><span class="gu-cp-dot">🛍️</span></div>' +
      node(0, 45) + node(1, 100) + '</div>' +
      (burst ? '<div class="gu-cp-confetti" aria-hidden="true"><i>🎉</i><i>✨</i><i>🎊</i><i>✨</i><i>🎉</i></div>' : '');
  }

  function refreshDrawerItems() {
    if (isCartPage) { window.location.reload(); return; }
    fetch('/?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshItems = doc.querySelector('.scd__items');
      var freshSub = doc.querySelector('[data-cart-subtotal-price]');
      var curBody = document.querySelector('.scd__wrapper:not(.sf-cart) .scd__body');
      if (curBody) {
        var curItems = curBody.querySelector('.scd__items');
        var empty = curBody.querySelector('.scd-empty-msg');
        if (freshItems) {
          if (curItems) { curItems.innerHTML = freshItems.innerHTML; }
          else if (empty) { empty.outerHTML = '<div class="scd__items">' + freshItems.innerHTML + '</div>'; }
        }
      }
      var curSub = document.querySelector('.scd__wrapper:not(.sf-cart) [data-cart-subtotal-price]');
      if (curSub && freshSub) curSub.innerHTML = freshSub.innerHTML;
    });
  }

  // what goes WITH a type (not more of the same)
  var GROUPS = {
    dress: ['dress', 'jumpsuit', 'co-ord', 'coord', 'set'],
    top: ['top', 'tee', 't-shirt', 'shirt', 'tank', 'blouse', 'corset'],
    bottom: ['skirt', 'bottom', 'pant', 'trouser', 'jean', 'short'],
    layer: ['waistcoat', 'vest', 'jacket', 'shrug', 'blazer', 'cardigan']
  };
  var PAIRS = { dress: ['layer'], top: ['bottom', 'layer'], bottom: ['top', 'layer'], layer: ['dress', 'bottom'] };
  function group(type) {
    type = (type || '').toLowerCase();
    var order = ['layer', 'dress', 'bottom', 'top'];
    for (var i = 0; i < order.length; i++) {
      var g = GROUPS[order[i]];
      for (var j = 0; j < g.length; j++) if (type.indexOf(g[j]) > -1) return order[i];
    }
    return 'other';
  }

  function renderXsell(cartData) {
    var el = document.querySelector('[data-gu-xsell]');
    if (!el || el.dataset.guLoaded) return;
    el.dataset.guLoaded = '1';
    var src = document.getElementById('gu-hot-json');
    var hot = [];
    try { hot = JSON.parse(src ? src.textContent : '[]').filter(Boolean); } catch (e) {}
    if (!hot.length || !cartData.items.length) { el.innerHTML = ''; return; }
    var inCart = cartData.items.map(function (i) { return i.product_id; });
    var cartGroups = cartData.items.map(function (i) { return group(i.product_type); });
    var want = [];
    cartGroups.forEach(function (g) { (PAIRS[g] || []).forEach(function (w) { if (want.indexOf(w) === -1 && cartGroups.indexOf(w) === -1) want.push(w); }); });
    var pool = hot.filter(function (p) { return inCart.indexOf(p.id) === -1; });
    var pick = pool.filter(function (p) { return want.indexOf(group(p.t)) > -1; });
    if (pick.length < 4) pick = pick.concat(pool.filter(function (p) { var g = group(p.t); return pick.indexOf(p) === -1 && cartGroups.indexOf(g) === -1; }));
    pick = pick.slice(0, 6);
    if (!pick.length) { el.innerHTML = ''; return; }
    el.innerHTML = '<div class="gu-xs-title">complete the look ✨</div><div class="gu-xs-row">' + pick.map(function (p, k) {
      var cmp = p.c > p.p ? '<s>' + inr(p.c) + '</s>' : '';
      return '<div class="gu-xs-card" data-k="' + k + '">' +
        '<a href="/products/' + p.h + '"><img src="' + p.i + '" alt="" loading="lazy"></a>' +
        '<div class="gu-xs-name">' + p.n.toLowerCase() + '</div>' +
        '<div class="gu-xs-foot"><span class="gu-xs-price">' + inr(p.p) + ' ' + cmp + '</span>' +
        '<button type="button" class="gu-xs-add">+ add</button></div>' +
        '<div class="gu-xs-sizes" hidden>' + p.s.map(function (s) { return '<button type="button" data-vid="' + s[0] + '">' + s[1] + '</button>'; }).join('') + '</div>' +
        '</div>';
    }).join('') + '</div>';
    el.querySelectorAll('.gu-xs-card').forEach(function (card) {
      var add = card.querySelector('.gu-xs-add'), sizes = card.querySelector('.gu-xs-sizes');
      add.addEventListener('click', function () {
        if (sizes.children.length === 1) { sizes.children[0].click(); return; }
        sizes.hidden = !sizes.hidden; add.textContent = sizes.hidden ? '+ add' : 'pick size';
      });
      sizes.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          add.textContent = '…'; sizes.hidden = true;
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(b.dataset.vid, 10), quantity: 1 }) })
            .then(function () { add.textContent = 'added ✓'; add.disabled = true; refreshDrawerItems(); })
            .catch(function () { add.textContent = '+ add'; });
        });
      });
    });
  }

  var origFetch = window.fetch;
  function update() {
    origFetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var base = (typeof c.original_total_price === 'number') ? c.original_total_price : c.total_price;
      renderProgress(base, Math.max(0, base - c.total_price));
      renderXsell(c);
    }).catch(function () {});
  }

  window.fetch = function () {
    var url = '';
    try { url = String(arguments[0] && arguments[0].url ? arguments[0].url : arguments[0]); } catch (e) {}
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(update, 350); }, function () {});
    }
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (/\/cart\/(add|change|update|clear)/.test(String(url))) {
      this.addEventListener('loadend', function () { setTimeout(update, 350); });
    }
    return origOpen.apply(this, arguments);
  };

  document.addEventListener('DOMContentLoaded', function () {
    update();
    var wrapper = document.querySelector('.scd__wrapper');
    if (wrapper) {
      new MutationObserver(function () { update(); }).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    }
  });
})();
